import { useEffect, useRef } from 'react';
import { ABSOLUTE_MS, ensureSessionStart, isAbsoluteExpired } from './sessionTimeout.ts';

// Fires onExpire once when the admin crosses the 48-hour absolute limit while
// enabled. There is no idle timeout: the session is deliberately long-lived and
// the JWT refreshes silently, so activity tracking would add complexity without
// changing when a session ends.
export function useSessionTimeout({
  enabled,
  onExpire,
}: {
  enabled: boolean;
  onExpire: () => void;
}): void {
  const fired = useRef(false);
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;

  useEffect(() => {
    if (!enabled) return;
    fired.current = false;
    const start = ensureSessionStart(Date.now());
    const check = () => {
      if (fired.current) return;
      if (!isAbsoluteExpired(start, Date.now(), ABSOLUTE_MS)) return;
      fired.current = true;
      onExpireRef.current();
    };
    const interval = window.setInterval(check, 30_000);
    return () => {
      window.clearInterval(interval);
    };
  }, [enabled]);
}
